import React from "react";
import PasswordResetToken from "../../components/auth/ResetPasswordToken";

export default function ResetPasswordTokenPage() {
  return <PasswordResetToken />;
}
